export const Timer = {
    async wait(milliseconds = 1000) {
        await new Promise(resolve => setTimeout(resolve, milliseconds));
    }
}
